/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const LOGICAL_MODEL_MEASURE = "logicalmodel-measure";
export const LOGICAL_MODEL_MEASURE_GROUP = "logicalmodel-measuregroup";
export const LOGICAL_MODEL_DIMENSION_DATA_ACCESS = 'logicalmodel-dimension.dataAccess';
export const LOGICAL_MODEL_DIMENSION_ATTRIBUTE_ACCESS = 'logicalmodel-dimension.attributeAccess';
export const LOGICAL_MODEL_DIMENSION_HIERARCHY_ACCESS = 'logicalmodel-dimension.hierarchyAccess';
export const LOGICAL_MODEL_DIMENSION = 'logicalmodel-dimension';
export const POLICY = 'policy';
export const FETCH_ACTIONS_ERROR = 'Error in fetching action data: {0}';
